import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { AlertService, HttpService } from '../../../services';

@Component({
  selector: 'app-form-drop-zone',
  templateUrl: './form-drop-zone.component.html',
  styleUrls: ['./form-drop-zone.component.css']
})
export class FormDropZoneComponent implements OnInit, OnChanges {

  @Input() config: DropzoneConfigInterface;
  @Input() disabled: boolean;
  @Input() disableUpload: boolean;
  @Input() text: string;
  @Output() upload = new EventEmitter();
  @Output() fileChange = new EventEmitter();
  @Output() cancelChangeUpload = new EventEmitter();

  file: any;
  uploading: boolean;
  newProfilePhoto: boolean;
  originalText: string;
  allowedFileExtensions: string[] = ['jpg', 'jpeg', 'png', 'pdf'];

  constructor(
    private alertService: AlertService,
    private httpService: HttpService
  ) { }

  ngOnInit() {
  }

  clear() {
    this.file = null;
    this.text = this.originalText;
  }

  ngOnChanges(data) {
    if (data.config) {
      this.config = {
        ...{
          url: '',
          acceptedFiles: 'application/pdf,image/png,image/jpeg',
          uploadMultiple: false,
          autoProcessQueue: false,
          autoQueue: false,
          previewsContainer: false,
          clickable: true,
          maxFilesize: 1, // MB
          parallelUploads: 1
        },
        ...this.config
      };
    }

    if (data.text) {
      this.originalText = this.text;
    }
  }

  onUploadSuccess(event) {
    // console.log('success', event);
  }

  onUploadError(event) {
    // console.log('onUploadError', event);
  }

  onComplete(event) {
    // console.log('onComplete', event);
  }

  onAdd(event) {
    //console.log(event);
    this.text = event.name;
    const fileExtension = event.name.split('.').pop();
    if (fileExtension && this.allowedFileExtensions.includes(fileExtension)) {
      this.fileChange.emit(event);
      this.newProfilePhoto = true;
    }
    else {
      this.alertService.warnHigh("This file type is not allowed for upload. Please choose a file with the following extensions: .jpg, .jpeg, .png, .pdf.")
      this.cancelUploadNewPhoto();
    }

    //if (!this.disableUpload) {
    //  this.disabled = true;
    //  this.uploading = true;

    //  const fileToUpload = event;
    //  const fileName = event.name;

    //  this.httpService.upload(this.config.url as string, fileToUpload, fileName).pipe(finalize(() => {
    //    this.disabled = false;
    //    this.uploading = false;
    //  })).subscribe(
    //    res => {
    //      this.upload.emit(res[0]);
    //      this.file = res[0];
    //      this.fileChange.emit(this.file);
    //    }
    //  );
    //} else {
    //  this.text = event.name;
    //}
  }

  cancelUploadNewPhoto() {
    this.newProfilePhoto = false;
    this.text = "Drop file here to upload";
    this.cancelChangeUpload.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/form-drop-zone/form-drop-zone.component.ts